import { format } from "date-fns";
import { OrderType } from "../enums";

const style = `<style type="text/css">
  div {
      height: 100mm;
      width: 100mm;
      margin: 1.5mm;
      padding: 0 1.5mm 0 1.5mm;
      color: #782125;
      border: 1px solid black;
  }
  p {
      margin: 0;
      padding-left: 10mm;
      font-size: 1.5rem;
  }
  @media  print {
      body *{
          visibility: visible;
      }
     div {
        border: 1px solid #000;
      }
  }
</style>`;

export function getInnerHtmlForPunchingPrev(
  orderDetails,
  newUps,
  newMeter,
  totlaLable
) {
  const order_date = orderDetails.created_at;
  switch (orderDetails?.order_type * 1) {
    case OrderType["Barcode"]: {
      const date = orderDetails.status?.punching_date;
      return `${style}<div style="">
      <p>&nbsp;</p>
            <p>Date: ${format(new Date(order_date), "dd-LLL-yyyy")}</p>
            <p>TEETH: ${orderDetails?.teeth}</p>
            <p>SIZE: ${orderDetails?.size}</p>
            <p>${newUps} UPS &nbsp; ${orderDetails?.cut}</p>
            <p>Paper: ${orderDetails?.paper_type}</p>
            <p>Color: ${orderDetails?.color || ""}</p>
            <p>Paper-size: ${orderDetails?.paper_size}</p>
            <p>METER: ${newMeter}</p>
            <p>LABEL: ${totlaLable}</p>
            <p>Punching: ${
              date ? format(new Date(date), "dd-LLL-yyyy hh-mm a") : ""
            }  </p>
            </div>`;
    }
    case OrderType["Sheet"]:
    case OrderType["Color"]: {
      const date = orderDetails.status?.punching_date;
      return `${style}<div style="color: #782125">
            <p>&nbsp;</p>
            <p>Date: ${format(new Date(order_date), "dd-LLL-yyyy")}</p>
            <p>SIZE: ${orderDetails?.size}</p>
            <p>${newUps} UPS ${orderDetails.cut} </p>
            <p>Brand Name : ${
              orderDetails?.brand_name ? orderDetails?.brand_name : "--"
            }</p>
            <p>Color : ${orderDetails?.color || ""}</p>
            <p>Paper Type: ${orderDetails?.paper_type}</p>
            <p>PAPER SIZE ${orderDetails?.paper_size}</p>
            <p>METER: ${newMeter}</p>
            <p>LABEL: ${totlaLable}</p>
            <p>Punching: ${
              date ? format(new Date(date), "dd-LLL-yyyy hh-mm a") : ""
            }  </p>
            </div>`;
    }

    case OrderType["Paper"]: {
      const date = orderDetails.status?.punching_date;
      return `${style}<div style="color: #782125;">
      <p>&nbsp;</p>
      <p>Date: ${format(new Date(order_date), "dd-LLL-yyyy")}</p>
            <p>SIZE: ${orderDetails?.paper_size}</p>
            <p>${orderDetails.mtr_daya === "mtr" ? "METER" : "DAYA"} : ${
        orderDetails?.daya_mtr
      }</p>
            <p>CORE : ${orderDetails?.core}</p>
            <p>Paper Type: ${orderDetails?.paper_type}</p>
            <p>Brand Name : ${
              orderDetails?.brand_name ? orderDetails?.brand_name : "--"
            }</p>
            <p>ROLL : ${
              orderDetails?.roll - (orderDetails?.ready_roll || 0)
            }</p>
            <p>PAPER SIZE : </p>
            <p>Punching: ${
              date ? format(new Date(date), "dd-LLL-yyyy hh-mm a") : ""
            } </p>
            </div>`;
    }
    default:
      return "something went wrong";
  }
}

export function getInnerHtmlForSlittingPrev(orderDetails) {
  return `${style}<div class="slitting" style="color: #782125">
  <p>&nbsp;</p>
    <p>Size: ${orderDetails?.paper_size}</p>
    <p>Qntity: ${orderDetails?.roll}</p>
    <p>Core: ${orderDetails?.core}"${orderDetails?.ups} ups</p>
    <p>Paper Type: ${orderDetails?.paper_type}</p>
    <p>Color: ${orderDetails?.color || ""}</p>
    <p>${orderDetails?.splitting_note ? orderDetails?.splitting_note : ""}</p>
</div>`;
}
